import { tip as d3tip } from "d3-v6-tip";
import * as d3 from "d3";

export const tip = d3tip()
    .attr('class', 'd3-tip')
    .offset([-10, 0])
    .html(function (event, gene) {
        // console.log(d3.select(event.relatedTarget).node().parentNode)
        // console.log(gene)
        // console.log(d3.select(this))


        const curGenome = d3.select(this).node()
            .parentNode.__data__;


        // console.log(curGenome)
        // console.log(gene.__p)

        // let tmp = d3.select(this).style('stroke')
        // console.log(tmp)
        // d3.select(this).style('stroke','black')

        var curType = d3.select("#plot").attr("class")

        var strand;
        var pro;
        var proID;
        var genID;
        var idn;
        var ecn;
        var coo;
        var str;
        var gel;
        var tra;
        var prl;

        var kegg;
        var pfam;
        var tigrfam;

        // var metas = "";
        // if(curGenome['track_meta']){
        //     metas = curGenome['track_meta'].map((value,index)=>{
        //         return "<strong>" +value+ ": </strong> <span>" + gene[value] + "</span><br>"
        //     })
        //     metas = metas.join('')
        // }

        var uniqueGenome = ""
        if(curGenome['unique_genome']){
            uniqueGenome = "<strong>Genome:</strong> <span>" + curGenome['unique_genome'] + "</span><br>"
        }

        let result_tip = ''

        // for upload files
        if (curType === "upload"|| curType === "null") {
            if (gene["product"] !== null && gene["product"] !== "none") {
                pro = "<strong>Product:</strong> <span>" + gene["product"] + "</span><br>"
            } else {
                pro = ''
            }

            if (gene["protein"] !== null && gene["protein"] !== "none") {
                proID = "<strong>Protein ID:</strong> <span>" + gene["protein"] + "</span><br>"
            } else {
                proID = ''
            }


            if (gene["gene"] !== null && gene["gene"] !== "none") {
                genID = "<strong>Gene:</strong> <span>" + gene["gene"] + "</span><br>"
            } else {
                genID = ''
            }

            // if (gene["id"] !== null && gene["id"] !== null) {
            //     idn = "<strong>ID:</strong> <span>" + gene["id"] + "</span><br>"
            // } else {
            //     idn = ''
            // }

            if (gene["ec_number"] !== null && gene["ec_number"] !== "none") {
                ecn = "<strong>EC Number:</strong> <span>" + gene["ec_number"] + "</span><br>"
            } else {
                ecn = ''
            }

            if ((gene["start"] !== null && gene["end"] !== "none") && (gene["start"] !== null && gene["end"] !== "none")) {
                coo = "<strong>Coordinates:</strong> <span>" + gene["start"] + ".." + gene["end"] + "</span><br>"
            } else {
                coo = ''
            }

            if (gene["strand"] !== null && gene["strand"] !== "none") {
                if (gene["strand"] === 1) {
                    strand = "positive (+)"
                } else if (gene["strand"] === -1) {
                    strand = "negative (-)"
                }
                str = "<strong>Strand:</strong> <span>" + strand + "</span><br>"
            } else {
                str = ''
            }

            if (gene["gene_length"] !== null && gene["gene_length"] !== "none") {
                gel = "<strong>CDS length:</strong> <span>" + gene["gene_length"] + "</span><br>"
            } else {
                gel = ''
            }

            let annotations_result = ''
            Object.keys(gene['annotations']).map((key,index)=>{

                // console.log(Object.keys(gene['annotations'][key]))
                let key_list = Object.keys(gene['annotations'][key])
                if (key_list.every(each_key=> each_key.length === 0)){
                    return
                }

                if(key_list.length === 0){
                    return
                }
                // let curDatabase = key
                annotations_result += `<strong>${key}:</strong> <span>`
                let annotation_list = Object.keys(gene['annotations'][key]).map((id,index)=>{

                    if(gene['annotations'][key][id].length !== 0){
                        return id + " (" + gene['annotations'][key][id] + ")"
                    }
                    else{
                        return id
                    }
                })

                let annotation_str = annotation_list.filter(Boolean).join(', ')
                annotations_result = annotations_result + annotation_str + "</span><br>"
            })

            //
            // if (gene["protein_length"] !== null && gene["protein_length"] !== "none") {
            //     prl = "<strong>Protein Length:</strong> <span>" + gene["protein_length"] + "</span><br>"
            // } else {
            //     prl = ''
            // }

            // return pro + proID + genID + idn + ecn + coo + str + gel + prl
            // return pro + proID + genID  + coo + str + gel + prl

            // result_tip = uniqueGenome + metas + pro + proID + genID  + coo + gel
            // result_tip = uniqueGenome  + pro + proID + genID  + coo + gel
            result_tip = uniqueGenome   + proID  + annotations_result + coo + gel
            return result_tip
        }

        // for csv files that are uploaded in ncbi format
        else if (curType === "ncbi_csv") {


            if (gene["protein"] !== null && gene["protein"] !== "none" && gene["protein"] !== "") {
                // pro = "<strong>Gene name:</strong> <span>" + gene["product"] + "</span><br>"
                pro = "<strong>Protein ID:</strong> <span>" + gene["protein"] + "</span><br>"
            } else {
                pro = ''
            }

            if (gene["ncbi_gene"] !== null && gene["ncbi_gene"] !== "none" && gene["ncbi_gene"] !== "") {
                // pro = "<strong>Gene name:</strong> <span>" + gene["product"] + "</span><br>"
                genID = "<strong>Gene name:</strong> <span>" + gene["ncbi_gene"] + "</span><br>"
            } else {
                genID = ''
            }


            if (gene["product"] !== null && gene["product"] !== "none" && gene["product"] !== "") {
                // pro = "<strong>Gene name:</strong> <span>" + gene["product"] + "</span><br>"
                proID = "<strong>Product:</strong> <span>" + gene["product"] + "</span><br>"
            } else {
                proID = ''
            }



            // if (gene["kegg_id"] !== null && gene["kegg_id"] !== "none" && gene["kegg_id"] !== "") {
            //     kegg = "<strong>KEGG ID: </strong> <span>" + gene["kegg_id"] + "</span><br>"
            // } else {
            //     kegg = ''
            // }
            //
            // if (gene["pfam_id"] !== null && gene["pfam_id"] !== "none"  && gene["pfam_id"] !== "") {
            //     pfam = "<strong>Pfam ID: </strong> <span>" + gene["pfam_id"] + "</span><br>"
            // } else {
            //     pfam = ''
            // }
            //
            // if (gene["tigrfam_id"] !== null && gene["tigrfam_id"] !== "none"  && gene["tigrfam_id"] !== "") {
            //     tigrfam = "<strong>TIGRFAM ID: </strong> <span>" + gene["tigrfam_id"] + "</span><br>"
            // } else {
            //     tigrfam = ''
            // }

            let annotations_result = ''
            Object.keys(gene['annotations']).map((key,index)=>{

                // console.log(Object.keys(gene['annotations'][key]))
                let key_list = Object.keys(gene['annotations'][key])
                if (key_list.every(each_key=> each_key.length === 0)){
                    return
                }

                if(key_list.length === 0){
                    return
                }
                // let curDatabase = key
                annotations_result += `<strong>${key}:</strong> <span>`
                let annotation_list = Object.keys(gene['annotations'][key]).map((id,index)=>{

                    if(gene['annotations'][key][id].length !== 0){
                        return id + " (" + gene['annotations'][key][id] + ")"
                    }
                    else{
                        return id
                    }
                })

                let annotation_str = annotation_list.filter(Boolean).join(', ')
                annotations_result = annotations_result + annotation_str + "</span><br>"
            })

            // if (gene["gene"] !== null && gene["gene"] !== "none") {
            //     proID = "<strong>Protein ID:</strong> <span>" + gene["gene"] + "</span><br>"
            // } else {
            //     proID = ''
            // }




            // if (gene["id"] !== null && gene["id"] !== null) {
            //     idn = "<strong>ID:</strong> <span>" + gene["id"] + "</span><br>"
            // } else {
            //     idn = ''
            // }

            if (gene["ec_number"] !== null && gene["ec_number"] !== null) {
                ecn = "<strong>EC Number:</strong> <span>" + gene["ec_number"] + "</span><br>"
            } else {
                ecn = ''
            }

            if ((gene["start"] !== null && gene["end"] !== null) && (gene["start"] !== null && gene["end"] !== null)) {
                coo = "<strong>Coordinates:</strong> <span>" + gene["start"] + ".." + gene["end"] + "</span><br>"
            } else {
                coo = ''
            }

            if (gene["strand"] !== null && gene["strand"] !== null) {
                if (gene["strand"] === 1) {
                    strand = "positive (+)"
                } else if (gene["strand"] === -1) {
                    strand = "negative (-)"
                }
                str = "<strong>Strand:</strong> <span>" + strand + "</span><br>"
            } else {
                str = ''
            }

            if (gene["gene_length"] !== null && gene["gene_length"] !== null) {
                gel = "<strong>CDS length:</strong> <span>" + gene["gene_length"] + "</span><br>"
            } else {
                gel = ''
            }

            // if (gene["protein_length"] !== null && gene["protein_length"] !== null) {
            //     prl = "<strong>Protein Length:</strong> <span>" + gene["protein_length"] + "</span><br>"
            // } else {
            //     prl = ''
            // }

            // return pro + proID + genID + idn + ecn + coo + str + gel + prl
            // return pro+ kegg + pfam + tigrfam  +  coo + str + gel + prl

            // result_tip = uniqueGenome+ metas +pro + genID + proID + kegg + pfam + tigrfam  +  coo + gel
            result_tip = uniqueGenome +pro + genID + proID + annotations_result +  coo + gel
            return result_tip
        }

        //gtdb_csv and annotree_search
        else{

            if (gene["protein"] !== null && gene["protein"] !== "none" && gene["protein"] !== "") {
                // pro = "<strong>Gene name:</strong> <span>" + gene["product"] + "</span><br>"
                pro = "<strong>Gene name:</strong> <span>" + gene["protein"] + "</span><br>"
            } else {
                pro = ''
            }


            // if (gene["kegg_id"] !== null && gene["kegg_id"] !== "none" && gene["kegg_id"] !== "") {
            //     kegg = "<strong>KEGG ID: </strong> <span>" + gene["kegg_id"] + "</span><br>"
            // } else {
            //     kegg = ''
            // }
            //
            // if (gene["pfam_id"] !== null && gene["pfam_id"] !== "none"  && gene["pfam_id"] !== "") {
            //     pfam = "<strong>Pfam ID: </strong> <span>" + gene["pfam_id"] + "</span><br>"
            // } else {
            //     pfam = ''
            // }
            //
            // if (gene["tigrfam_id"] !== null && gene["tigrfam_id"] !== "none"  && gene["tigrfam_id"] !== "") {
            //     tigrfam = "<strong>TIGRFAM ID: </strong> <span>" + gene["tigrfam_id"] + "</span><br>"
            // } else {
            //     tigrfam = ''
            // }

            let annotations_result = ''

            Object.keys(gene['annotations']).map((key,index)=>{


                let key_list = Object.keys(gene['annotations'][key])
                if (key_list.every(each_key=> each_key.length === 0)){
                    return
                }

                if(key_list.length === 0){
                    return
                }
                // let curDatabase = key
                annotations_result += `<strong>${key}:</strong> <span>`
                let annotation_list = Object.keys(gene['annotations'][key]).map((id,index)=>{

                    if(gene['annotations'][key][id].length !== 0){
                        return id + " (" + gene['annotations'][key][id] + ")"
                    }
                    else{
                        return id
                    }
                })

                let annotation_str = annotation_list.filter(Boolean).join(', ')
                annotations_result = annotations_result + annotation_str + "</span><br>"
            })

            if ((gene["start"] !== null && gene["end"] !== null) && (gene["start"] !== null && gene["end"] !== null)) {
                coo = "<strong>Coordinates:</strong> <span>" + gene["start"] + ".." + gene["end"] + "</span><br>"
            } else {
                coo = ''
            }

            if (gene["strand"] !== null && gene["strand"] !== null) {
                if (gene["strand"] === 1) {
                    strand = "positive (+)"
                } else if (gene["strand"] === -1) {
                    strand = "negative (-)"
                }
                str = "<strong>Strand:</strong> <span>" + strand + "</span><br>"
            } else {
                str = ''
            }

            if (gene["gene_length"] !== null && gene["gene_length"] !== null) {
                gel = "<strong>CDS length:</strong> <span>" + gene["gene_length"] + "</span><br>"
            } else {
                gel = ''
            }



            // result_tip = uniqueGenome+ metas +pro  +annotations_result +   coo + gel
            result_tip = uniqueGenome +pro  +annotations_result +   coo + gel
            return result_tip
        }
    });